module.exports = __webpack_public_path__ + "img/app2.126889f2.png";